export const labTabs = [
  "RETATRUTIDE",
  "SEMAGLUTIDE",
  "TIRZEPATIDE",
  "GHK-CU",
  "MELATONAN-II",
  "IGF-1 LR3",
  "IPAMORELIN",
  "SELANK",
];

export const labData = [
  {
    id: "retatrutide",
    tabName: "RETATRUTIDE",
    reportImage: "/lab/101.avif", 
    tableData: {
      contentMeasured: "20 mg",
      purity: "99.34%",
      laboratory: "Axiom Analytics",
      taskNumber: "37722",
      verificationCode: "VLAB20260VIN",
      analysisDate: "16-01-2026",
      verificationLink: "https://axiomanalytics.cz/results/VLAB-2026-732323"
    },
    productLink: "/shopDetails/reta_23"
  },
  {
    id: "semaglutide",
    tabName: "SEMAGLUTIDE",
    reportImage: "/lab/102.avif",  
    tableData: {
      contentMeasured: "10 mg",
      purity: "99.19%",
      laboratory: "Axiom Analytics",
      taskNumber: "64548",
      verificationCode: "VLAB20269U4I",
      analysisDate: "16-01-2026",
      verificationLink: "https://axiomanalytics.cz/results/VLAB-2026-111666"
    },
    productLink: "/shopDetails/semaglutide_26"
  },
  // 3
  {
    id: "tirzepatide",
    tabName: "TIRZEPATIDE",
    reportImage: "/lab/103.avif", 
    tableData: {
      contentMeasured: "10mg mg",
      purity: "99.83%",
      laboratory: "Axiom Analytics",
      taskNumber: "33639",
      verificationCode: "VLAB2026MCQB",
      analysisDate: "16-01-2026",
      verificationLink: "https://axiomanalytics.cz/results/VLAB-2026-606587"
    },
    productLink: "/shopDetails/tirzepatide_35"
  },
  // 4
  {
    id: "ghk-cu",
    tabName: "GHK-CU",
    reportImage: "/lab/104.avif", 
    
    tableData: {
      contentMeasured: "50mg mg",
      purity: "99.40%",
      laboratory: "Axiom Analytics",
      taskNumber: "49720",
      verificationCode: "VLAB20268BDE",
      analysisDate: "16-01-2026",
      verificationLink: "https://axiomanalytics.cz/results/VLAB-2026-788796"
    },
    productLink: "/shopDetails/GHK-CU_24"
  },
  // 5
  {
    id: "melatonan-ii",
    tabName: "MELATONAN-II",
    reportImage: "/lab/105.avif", 
    
    tableData: {
      contentMeasured: "",
      purity: "99.49%",
      laboratory: "Axiom Analytics",
      taskNumber: "00962",
      verificationCode: "VLAB202662QW",
      analysisDate: "16-01-2026",
      verificationLink: "https://axiomanalytics.cz/results/VLAB-2026-765377"
    },
    productLink: "/shopDetails/melanotan-ii_25"
  },
  // 6
  {
    id: "igf-1-lr3",
    tabName: "IGF-1 LR3",
    reportImage: "/lab/106.avif", 
    
    tableData: {
      contentMeasured: "1mg mg",
      purity: "99.34%",
      laboratory: "Axiom Analytics",
      taskNumber: "78917",
      verificationCode: "VLAB2026GWJJ",
      analysisDate: "16-01-2026",
      verificationLink: "https://axiomanalytics.cz/results/J-2026-796636"
    },
    productLink: "/shopDetails/IGF-1%20LR3_54"
  },
  {
    id: "ipamorelin",
    tabName: "IPAMORELIN",
    reportImage: "/lab/107.avif", 
    
    tableData: {
      contentMeasured: "",
      purity: "99.16%",
      laboratory: "Axiom Analytics",
      taskNumber: "90417",
      verificationCode: "VLAB20261P95",
      analysisDate: "16-01-2026",
      verificationLink: "https://axiomanalytics.cz/results/VLAB-2026-150768"
    },
    productLink: "/shopDetails/ipamorelin_27"
  },
  {
    id: "selank",
    tabName: "SELANK",
    reportImage: "/lab/108.avif", 
    
    tableData: {
      contentMeasured: "10 mg",
      purity: "99.59%",
      laboratory: "Axiom Analytics",
      taskNumber: "00962",
      verificationCode: "VLAB2026S0DC",
      analysisDate: "16-01-2026",
      verificationLink: "https://axiomanalytics.cz/results/VLAB-2026-917133"
    },
    productLink: "/shopDetails/selank_39"
  }
];
